/* Pedido minimo — El Laboratorio del Bazar
   Bloquea el pago cuando el carrito no llega al minimo y le dice al cliente
   cuanto le falta. Falla ABIERTO: si algo sale mal, no estorba la compra. */
(function () {
  'use strict';

  var MINIMO = 50000;          // en pesos
  var CLASE_AVISO = 'lb-min-aviso';

  function pesos(n) {
    try {
      return '$' + Math.round(n).toLocaleString('es-CO');
    } catch (e) {
      return '$' + Math.round(n);
    }
  }

  function botonesPago() {
    var sels = [
      '[name="checkout"]',
      '.cart__checkout-button',
      '#checkout',
      'button[form="cart"]',
      '.cart-drawer__checkout'
    ];
    var out = [];
    sels.forEach(function (s) {
      try {
        Array.prototype.forEach.call(document.querySelectorAll(s), function (el) {
          if (out.indexOf(el) === -1) out.push(el);
        });
      } catch (e) {}
    });
    return out;
  }

  function quitarAvisos() {
    Array.prototype.forEach.call(document.querySelectorAll('.' + CLASE_AVISO), function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
  }

  function pintarAviso(btn, falta) {
    var aviso = document.createElement('div');
    aviso.className = CLASE_AVISO;
    aviso.setAttribute('role', 'status');
    aviso.style.cssText =
      'margin:10px 0;padding:12px 14px;border-radius:12px;background:#FFF7ED;' +
      'border:1px solid #FED7AA;color:#9A3412;font-size:14px;line-height:1.5;';
    aviso.innerHTML =
      '<strong>Te faltan ' + pesos(falta) + '</strong> para el pedido mínimo de ' +
      pesos(MINIMO) + '.<br>Agrega otro producto y completas tu pedido.';
    btn.parentNode && btn.parentNode.insertBefore(aviso, btn);
  }

  function aplicar(total) {
    quitarAvisos();
    var falta = MINIMO - total;
    var btns = botonesPago();
    btns.forEach(function (btn) {
      if (falta > 0) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        pintarAviso(btn, falta);
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
    });
  }

  function revisar() {
    if (!botonesPago().length) return;   // no estamos en carrito ni cajon
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (carrito && typeof carrito.total_price === 'number' && carrito.item_count > 0) {
          aplicar(carrito.total_price / 100);
        }
      })
      .catch(function () { /* falla abierto: no tocar nada */ });
  }

  function arrancar() {
    revisar();
    var pendiente = null;
    var obs = new MutationObserver(function () {
      clearTimeout(pendiente);
      pendiente = setTimeout(revisar, 250);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', revisar);
    document.addEventListener('cart:refresh', revisar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
